import { render, staticRenderFns } from "./ChangeProgramComponent.vue?vue&type=template&id=0d2aeb84&"
import script from "./ChangeProgramComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeProgramComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports